import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import Button from "./Button";

class CreatePatientModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matricule: "",
      nom: "",
      prenom: "",
      email: "",
      telephone: "",
      portable: "",
      ville: "",
      codepostal: "",
      adresse: "",
      loading: false,
      error: "",
      validMatricule: null,
      validNom: null,
      validPrenom: null
    };
  }

  handleSave = async () => {
    // redirect if no user is logged in
    /*  if (!this.props.loggedInUserQuery.loggedInUser) {
        console.warn("only logged in users can create new posts");
        return;
      }*/

    const {
      matricule,
      nom,
      prenom,
      adresse,
      codepostal,
      ville,
      email,
      telephone,
      portable
    } = this.state;
    //    const authorId = this.props.loggedInUserQuery.loggedInUser.id;
    this.setState({
      loading: true
    });

    await this.props
      .createPatientMutation({
        variables: {
          matricule,
          nom,
          prenom,
          adresse,
          codepostal,
          ville,
          email,
          telephone,
          portable
        }
      })
      .then(ret => {
        const newPatient = ret.data.createPatient;
        this.setState(
          {
            loading: false,
            error: ""
          },
          () => {
            this.props.handleChangePatient(newPatient);
            this.props.toggleModal();
          }
        );
      })
      .catch(e => {
        e.graphQLErrors.forEach(error => {
          if (error.code === 3010) {
            this.setState({
              error: "Un patient avec cette matricule existe déjà!"
            });
          }
        });

        this.setState({
          loading: false
        });
        console.error("create patient", e);
      });
  };

  handleInput = (event, variable) => {
    this.setState(
      {
        [variable]: event.target.value
      },
      state => this.handleChange(state, variable)
    );
  };

  handleChange = (state, variable) => {
    if (variable === "matricule") {
      this.setState({
        validMatricule: this.state.matricule.length > 12
      });
    }
    if (variable === "nom") {
      this.setState({
        validNom: this.state.nom.length > 1
      });
    }
    if (variable === "prenom") {
      this.setState({
        validPrenom: this.state.prenom.length > 1
      });
    }
  };

  render() {
    return (
      <div className="modal is-active">
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Créez un patient</p>
          </header>
          <section className="modal-card-body">
            <div className="field">
              <label className="label">
                Entrez la matricule du nouveau patient{" "}
                <span className="tag is-warning">obligatoire</span>
              </label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "matricule")}
                  className={`input ${this.state.validMatricule === false
                    ? "is-danger"
                    : ""}
                  `}
                  value={this.state.matricule}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>

            <div className="field is-horizontal">
              <div className="field-body">
                <div className="field">
                  <label className="label">
                    Nom <span className="tag is-warning">obligatoire</span>
                  </label>
                  <div className="control">
                    <input
                      onChange={e => this.handleInput(e, "nom")}
                      className={`input ${this.state.validNom === false
                        ? "is-danger"
                        : ""}
                      `}
                      value={this.state.nom}
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">
                    Prénom <span className="tag is-warning">obligatoire</span>
                  </label>
                  <div className="control">
                    <input
                      onChange={e => this.handleInput(e, "prenom")}
                      className={`input ${this.state.validPrenom === false
                        ? "is-danger"
                        : ""}
                      `}
                      value={this.state.prenom}
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="field is-horizontal">
              <div className="field-body">
                <div className="field">
                  <label className="label">Numéro de portable</label>
                  <div className="control">
                    <input
                      onChange={e => this.handleInput(e, "portable")}
                      className="input"
                      value={this.state.portable}
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Numéro de téléphone fixe</label>
                  <div className="control">
                    <input
                      onChange={e => this.handleInput(e, "telephone")}
                      className="input"
                      value={this.state.telephone}
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="field is-horizontal">
              <div className="field-body">
                <div className="field">
                  <label className="label">Adresse</label>
                  <div className="control">
                    <input
                      onChange={e => this.handleInput(e, "adresse")}
                      className="input"
                      value={this.state.adresse}
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Code postal</label>
                  <div className="control">
                    <input
                      onChange={e => this.handleInput(e, "codepostal")}
                      className="input"
                      value={this.state.codepostal}
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-body">
                <div className="field">
                  <label className="label">Localité</label>
                  <div className="control">
                    <input
                      onChange={e => this.handleInput(e, "ville")}
                      className="input"
                      value={this.state.ville}
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Email</label>
                  <div className="control">
                    <input
                      onChange={e => this.handleInput(e, "email")}
                      className="input"
                      value={this.state.email}
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <footer className="modal-card-foot">
            <p className="has-text-danger">{this.state.error}</p>
            <Button text="Retour" onClick={this.props.toggleModal} />
            <Button
              color="#00893D"
              text="Sauvegarder"
              disabled={
                !this.state.validMatricule ||
                !this.state.validPrenom ||
                !this.state.validNom
              }
              onClick={this.handleSave}
            />
          </footer>
        </div>
      </div>
    );
  }
}

const CREATE_PATIENT_MUTATION = gql`
  mutation CreatePatientMutation(
    $matricule: String
    $nom: String!
    $prenom: String!
    $adresse: String
    $codepostal: String
    $email: String
    $portable: String
    $telephone: String
    $ville: String
  ) {
    createPatient(
      matricule: $matricule
      nom: $nom
      prenom: $prenom
      adresse: $adresse
      codepostal: $codepostal
      email: $email
      portable: $portable
      telephone: $telephone
      ville: $ville
    ) {
      id
      nom
      prenom
      matricule
    }
  }
`;

export default graphql(CREATE_PATIENT_MUTATION, {
  name: "createPatientMutation"
})(CreatePatientModal);



// WEBPACK FOOTER //
// ./src/components/utilities/CreatePatientModal.js